import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { STORAGE_KEYS } from '../../config/constants';

export const ConsentBanner: React.FC = () => {
  const { darkMode } = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEYS.STORAGE_CONSENT);
    if (!consent) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEYS.STORAGE_CONSENT, new Date().toISOString());
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className={`max-w-lg mx-auto rounded-xl px-5 py-4 shadow-2xl backdrop-blur-xl flex flex-col sm:flex-row items-start sm:items-center gap-3 ${
        darkMode
          ? 'bg-slate-800/95 border border-white/10 text-slate-300'
          : 'bg-white/95 border border-slate-200 text-slate-600'
      }`}>
        <p className="text-sm flex-1">
          This app uses local storage to save your preferences and session data.{' '}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={`underline ${darkMode ? 'text-violet-400 hover:text-violet-300' : 'text-violet-600 hover:text-violet-700'}`}
          >
            Privacy Policy
          </a>
        </p>
        <button
          onClick={handleAccept}
          className="px-4 py-2 rounded-lg text-sm font-medium bg-violet-600 hover:bg-violet-700 text-white transition-colors flex-shrink-0"
        >
          Accept
        </button>
      </div>
    </div>
  );
};
